import { faAngleLeft, faAngleRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { primaryColor, secondaryColor } from "../../../utils/comon";

const StepFooter = ({ step, onNext, onPrev, disableNext, disableNextTooltip, nextBtnText, isLoading = false }) => {
  const isActuallyDisabled = disableNext || !!disableNextTooltip;

  return (
    <div className="flex justify-between mt-8 border-t border-bordercolor pt-4">

      <button
        onClick={onPrev}
        className="px-3 py-2 border border-bordercolor bg-cardbg text-textsecondary hover:text-textprimary hover:bg-appbg rounded-md text-xs flex items-center gap-2"
      >
        <FontAwesomeIcon icon={faAngleLeft} />
        Back
      </button>

      <div className="relative group inline-block">
        <button
          onClick={onNext}
          disabled={isActuallyDisabled}
          className={`px-4 py-2 rounded-md text-xs font-bold flex items-center gap-2 transition-all duration-200
          ${isActuallyDisabled
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "shadow-sm hover:shadow-md active:scale-95"}`}
          style={!isActuallyDisabled ? { backgroundColor: "var(--color-secondaryaccent)", color: "var(--color-primaryaccent)", borderColor: "var(--color-accentborder)" } : {}}
          onMouseEnter={(e) => {
            if (!isActuallyDisabled) {
              e.currentTarget.style.backgroundColor = "var(--color-primaryaccent)";
              e.currentTarget.style.color = "var(--color-cardbg)";
            }
          }}
          onMouseLeave={(e) => {
            if (!isActuallyDisabled) {
              e.currentTarget.style.backgroundColor = "var(--color-secondaryaccent)";
              e.currentTarget.style.color = "var(--color-primaryaccent)";
            }
          }}
        >
          {isLoading ? <FontAwesomeIcon icon={faSpinner} className="animate-spin" /> : nextBtnText}
          <FontAwesomeIcon icon={faAngleRight} />
        </button>

        {disableNextTooltip && (
          <div className="absolute right-0 bottom-full mb-2 z-[999] invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-300 pointer-events-none">
            <div className="bg-[#1E293B] text-white text-xs font-medium py-1.5 px-3 rounded-lg shadow-xl whitespace-nowrap relative">
              {disableNextTooltip}
              <div className="w-2 h-2 bg-[#1E293B] rotate-45 absolute right-4 -bottom-1"></div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default StepFooter;